<ion-title *ngIf="!showLogo && !debugMode()" (click)="debugTap()">
  {{title}}
</ion-title>

<ion-img class="logo" *ngIf="showLogo && !debugMode()" src="../../assets/img/hunter.png" (click)="debugTap()"></ion-img>

<ion-title *ngIf="debugMode()" (click)="debugTap()">
  DEBUGGING
</ion-title>